export default __webpack_public_path__ + "static/media/services_toll.fb5c612a.svg";